import React from "react";
import Tippy from "@tippyjs/react";
import { FaCircle } from "react-icons/fa";
import { ReactComponent as GreenExp } from "../../../../../../../src/assets/utils/images/svgs/GCircle.svg"
import { ReactComponent as OrangeExp } from "../../../../../../../src/assets/utils/images/svgs/OCircle.svg"
import { ReactComponent as PinkAExp } from "../../../../../../../src/assets/utils/images/svgs/aaicon.svg"
import { ReactComponent as PinkExp } from "../../../../../../../src/assets/utils/images/svgs/PCircle.svg"
import { ReactComponent as PinkVExp } from "../../../../../../../src/assets/utils/images/svgs/vvicon.svg"
// import { ReactComponent as Wedrag } from '../../../../../../assets/utils/images/svgs/wedrag.svg'
import TextLimit from "Api/TextLimit";

const AVAILABILITY_CONFIG = {
  "+": { icon: FaCircle, color: "#3AC47D", tooltip: "Beschikbaar" },
  "!": { icon: FaCircle, color: "#FFA73F", tooltip: "Beschikbaarheid onbekend" },
  // 'w': { icon: Wedrag, tooltip: "Werkdagen zijn geblokkeerd" },
  "-": { icon: FaCircle, color: "#FB2E5F", tooltip: "Niet beschikbaar" },
  i: { icon: GreenExp, tooltip: "Beschikbaar maar al ingepland" },
  I: { icon: PinkExp, tooltip: "Niet beschikbaar maar al ingepland" },
  x: { icon: OrangeExp, tooltip: "Beschikbaarheid onbekend maar al ingepland" },
  V:{icon: PinkVExp, tooltip: "Voorlopig ingepland in ander verzoek"},
  A:{icon: PinkAExp, tooltip: "Aangevraagd in ander verzoek"}
};

export default function AvailabilityShiftCell({ getValue }) {
  const { availability, availabilityError, substitutor } = getValue();
  const config = AVAILABILITY_CONFIG[availability];

  if (substitutor) return <div className="text-center">{TextLimit.AfwezigeLimitOptionThree(substitutor?.firstName, substitutor?.middleName, substitutor?.lastName)}</div>

  return (
    <div className={`text-center ${!config ? "empty" : ""}`}>
      <Tippy content={config?.tooltip} placement="bottom">
        <span
          style={{

            width: config?.size || 40,
            height: config?.size || 40,
          }}
        >
          {config?.icon && (
            <config.icon
              color={config.color}
              size={(config.size || 24)}
            />
          )}
        </span>
      </Tippy>

    </div>
  );
}
